// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/subpart-5-scope.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/subpart-5-scope/subpart-5-scope.js';

mount([g0]);
